<template>
  <div class="mobileWarp">
    <mobileHeader @cCurl="cCurl"></mobileHeader>
    <MobileBulletFrame @close="closeBF" :pInfo="pInfo" v-if="pInfoShow"></MobileBulletFrame>
    <div class="mobile pw100" v-if="teamDetail">
      <TeamMobileView @goBack="goDetail(false)"></TeamMobileView>
    </div>
<!--    <scrolling-tip-view v-if="currenIndex == 0" ></scrolling-tip-view>-->
    <div class="fullpage-container" @touchmove.prevent="onTouchMove">
      <div class="fullpage-wp" v-fullpage="opts" ref="fullPage">
        <div class="page page-1">
          <div class="zwHeader"></div>
          <div class="page1Warp">
            <img src="@/assets/video/20240909133407_compressed.gif" alt="">
<!--            <video-->
<!--                ref="videoRef"-->
<!--                class="imgbg"-->
<!--                loop-->
<!--                id="video29"-->
<!--                muted-->
<!--                defaultMuted-->
<!--                autoplay=""-->
<!--                x5-playsinline="true"-->
<!--                playsinline-->
<!--                webkit-playsinline="true"-->
<!--                x-webkit-airplay="allow"-->
<!--                preload="auto"-->
<!--                x5-video-player-type="h5"-->
<!--                x5-video-player-fullscreen="true"-->
<!--                @loadeddata="playVideo"-->
<!--               >-->
<!--              <source  src="../../assets/video/mobile_bg.mp4" type="video/mp4" />-->
<!--            </video>-->
<!--            <video ref="videoRef" class="video" autoplay loop muted src="../../assets/video/mobile_bg.mp4"></video>-->
            <div class="welcomeText fAb">
              <div class="welcomeTextWarp">
                <div class="ttv ttvItem" ref="ttvRef">Better Choice</div>
                <div class="ttv1 ttvItem" ref="ttvRef1">Better Partner</div>
              </div>
            </div>
          </div>
        </div>
        <div class="page page-2">
          <div class="page2Warp flexB h100">
            <div class="zwHeader w100"></div>
            <div class="content flex1 w100">
              <div class="info">
                <div class="title fAb">BioTrack Capital</div>
                <div class="desc fOM" v-html="aboutInfo.one.desc">
                </div>
                <div class="moreBtn pl fAm" @click="goAbout">
                  Learn More
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="page page-3">
          <div class="page3Warp flexB h100">
            <div class="zwHeader w100"></div>
            <div class="content flex1 w100">
              <div class="title fAb">Selected Portfolio</div>
              <div class="list">
                <PortfolioView @openInfo="openBulletOpen" :pList="pList"></PortfolioView>
              </div>
              <div class="moreBtn fAm" @click="goPortfolio">
                Learn More
              </div>
            </div>
          </div>
        </div>

        <div class="page page-4">
          <div class="page4Warp flexB h100">
            <div class="zwHeader w100"></div>
            <div class="content flex1 w100">
              <div class="title fAb">Team</div>
              <div class="list">
                <TeamView @goDetail="goDetail" :isHome="true"  v-if="!teamDetail" :teamList="teamList"></TeamView>
<!--                <TeamDetailView v-else @goDetail="goDetail"></TeamDetailView>-->
              </div>
            </div>
          </div>
        </div>

        <div class="page page-5">
          <div class="page5Warp flexB h100">
            <div class="zwHeader w100"></div>
            <div class="content flex1 w100 h100">
              <div class="title fAb">News</div>
              <div class="list">
                <NewsView></NewsView>
              </div>
            </div>
          </div>
        </div>

        <div class="page page-7">
          <div class="page5Warp flexB h100">
            <div class="zwHeader w100"></div>
            <div class="content flex1 w100 h100">
              <div class="title fAb">Viewpoint</div>
              <div class="list">
                <div class="newRight">
                  <div class="homeAtrList">
                    <div class="homeAtrItem fOH" v-for="(v,i) in viewPointList" @click="goViewDetail(v)">
                      <div class="atrTitle">{{ v.title }}</div>
                      <div class="atrDesc">{{ v.time }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="moreBtn fAm" style="margin-bottom: 1.3rem" @click="goViewPoint">
                Learn More
              </div>
            </div>
          </div>
        </div>

        <div class="page page-6">
          <div class="page6Warp flexB h100">
            <div class="zwHeader w100"></div>
            <div class="content flex1 w100">
              <div class="cTop">
                <div class="title fAb">Contact us</div>
                <div class="contactList">
                  <div class="contactItem" v-for="v in contactList" :key="v.id">
                    <div class="contactItemTitle fOH">
                      {{ v.title }}
                    </div>
                    <div class="contactItemDesc fOH">
                      {{ v.desc }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="filingsWarp fOL">
                CopyRight Biotrack Capital .com All Rights Reserved 沪ICP备20013951号-1
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
import mobileHeader from '../Common/MobileHeader.vue'
import scrollingTipView from "@/components/Common/scrollingMobileTip.vue";
import PortfolioView from "@/components/Portfolio/mobile.vue";
import TeamView from "@/components/Team/mobile.vue";
import NewsView from "@/components/News/mobile.vue";
import store from "@/store";
import TeamDetailView from "@/components/Team/Detail/mobile.vue";
import TeamMobileView from "@/components/Mobile/teamDetail.vue";
import MobileBulletFrame from "@/components/Portfolio/MobileBulletFrame.vue";
export default {
  components:{
    MobileBulletFrame,
    TeamMobileView,
    NewsView,
    TeamView,
    PortfolioView,
    scrollingTipView,
    mobileHeader,
    TeamDetailView
  },
  data(){
    return {
      teamDetail:false,
      pInfo:{},
      pInfoShow:false,
      opts: {
        start: 0,
        dir: 'v',
        duration: 500,
        beforeChange: function (currentSlideEl,currenIndex,nextIndex) {
        },
        afterChange: function (currentSlideEl,currenIndex,nextIndex) {
          store.dispatch('setStoreByKeyData',{key:'setHomeIndex',data:currenIndex})
        }
      }
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.onBridgeReady()
    })
  },
  computed:{
    viewPointList() {
      return this.$store.getters.homeData.viewPointList;
    },
    teamList(){
      return this.$store.getters.homeData.teamList
    },
    currenIndex(){
      return this.$store.getters.pageCurrentIndex;
    },
    aboutInfo(){
      return this.$store.getters.homeData.aboutInfo
    },
    pList(){
      return this.$store.getters.homeData.homePortfolio
    },
    contactList(){
      return this.$store.getters.homeData.contactList
    },
    fGoHome(){
      return this.$store.getters.fGoHome
    },
    homeIndex(){
      return this.$store.getters.homeIndex;
    },
  },
  created() {
    var t = this
    this.$nextTick(r=>{
      t.ttvHideOrShow()
      var index = parseInt(t.fGoHome)
      t.opts.start = index
      if(index>0){
        setTimeout(r=>{
          this.$store.dispatch('setStoreByKeyData',{key:'setFGoHome',data:0})
        },200)
      }
    })
  },
  methods:{
    goDetail(flg){
      this.teamDetail = flg
      this.$refs.fullPage.$fullpage.setDisabled(flg)
    },
    cCurl(){
      if(this.homeIndex != 0){
        if(this.teamDetail || this.pInfoShow){
          this.teamDetail = false
          this.pInfoShow = false
          this.$refs.fullPage.$fullpage.setDisabled(false)
        }
        this.$refs.fullPage.$fullpage.moveTo(0,true)
      }
    },
    playVideo(){
      alert('进入 play success')
      this.$refs.videoRef.play().catch(error => {
        alert('加载视频错误' + err)
      }).then(res=>{
        alert('加载视频成功')
      });
    },
    ttvHideOrShow(){
      var t = this
      setTimeout(r=>{
        t.$refs.ttvRef.style.opacity = 0
        t.$refs.ttvRef1.style.opacity = 0
        // t.$refs.ttvRef.style.marginTop = '2rem'
        // t.$refs.ttvRef1.style.marginTop = '2rem'
        setTimeout(r=>{
          t.ttvHideOrShow()
        },1500)
      },8000)
      setTimeout(r=>{
        t.$refs.ttvRef1.style.opacity = 1
        // t.$refs.ttvRef1.style.marginTop = 0
      },2000)
      setTimeout(r=>{
        t.$refs.ttvRef.style.opacity = 1
        // t.$refs.ttvRef.style.marginTop = 0
      },500)
    },
    onBridgeReady(){
      var t = this
      if (window.WeixinJSBridge) {
        WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
          t.$refs.videoRef.play()
        }, false);
      } else {
        document.addEventListener("WeixinJSBridgeReady", function () {
          WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
            t.$refs.videoRef.play()
          });
        }, false);
      }
    },
    onTouchMove(event) {
      // 这里的 event 是触摸事件对象
      // 使用 .prevent 修饰符或者调用 event.preventDefault() 来阻止默认滚动行为
      event.preventDefault();
    },
    goAbout(){
      this.$router.push({name:'About'})
    },
    goPortfolio(){
      this.$router.push({name:'Portfolio'})
    },
    goViewPoint(){
      this.$router.push({name:'Viewpoint'})
    },
    async goViewDetail(v){
      if(v.id){
        await this.$store.dispatch('setStoreByKeyData', {key: 'setViewPointInfo', data: v})
        this.$router.push({name:"ViewpointDetail",query:{id:v.id}})
      }
    },
    closeBF(){
      this.$refs.fullPage.$fullpage.setDisabled(false)
      this.pInfoShow = false
    },
    openBulletOpen(v){
      this.pInfo = v
      this.pInfoShow = true
      this.$refs.fullPage.$fullpage.setDisabled(true)
    },
  }
}
</script>
<style scoped lang="scss">
.zwHeader{
  height: 4rem;
}
.moreBtn{
  padding: .8rem 0;
  border: .05rem solid #fff;
  width: 10rem;
  font-size: .8rem;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: center;
}
.page-6{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_6.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page6Warp{
    padding: 1.3rem;
    box-sizing: border-box;
    .content{
      flex: 1;
      overflow: hidden;
      color: #fff;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: space-between;
      .filingsWarp{
        font-size: .6rem;
        text-align: center;
        width: 100%;
      }
      .cTop{
        padding: 1rem 2rem;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        .contactList{
          margin-top: .5rem;
          .contactItem{
            margin-top: 1rem;
          }
          .contactItemTitle{
            font-size: 1.2rem;
          }
          .contactItemDesc{
            margin-top: .8rem;
            font-size: .9rem;
          }
        }
      }
      .title{
        font-size: 1.5rem;
        margin-top: -20vh;
      }
      .list{
        flex: 1;
        overflow: hidden;
      }
    }
  }
}
.page-7{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_7.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page5Warp{
    .content{
      flex: 1;
      overflow: hidden;
      color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      .title{
        font-size: 1.5rem;
        margin-top: 1rem;
      }
      .list{
        flex: 1;
        overflow: hidden;
        padding: 0 1.3rem 1rem;
        .newRight {
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
          height: 100%;
          .homeAtrList {
            .homeAtrItem {
              border-bottom: .12rem solid rgba(255, 255, 255, .4);
              padding: 1rem 0;

              .atrTitle {
                font-size: .75rem;
                color: #fff;
                line-height: 1.3rem;
              }

              .atrDesc {
                font-size: .7rem;
                margin-top: .5rem;
                color: #8FCADD;
              }

            }
          }
        }
      }
    }
  }
}
.page-5{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_5.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page5Warp{
    .content{
      flex: 1;
      overflow: hidden;
      color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      .title{
        font-size: 1.5rem;
        margin-top: 1rem;
      }
      .list{
        padding: 0 1.3rem;
        flex: 1;
        overflow: hidden;
      }
    }
  }
}

.page-4{
  height: 100%;
    background-image: url("../../assets/image/mobile/m_bg_4.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page4Warp{
    .content{
      color: #fff;
      display: flex;
      align-items: center;
      //justify-content: space-evenly;
      //justify-content: center;
      flex-direction: column;
      .title{
        font-size: 1.5rem;
        padding-top: .5rem;
        padding-bottom: 1rem;
      }
      .list{
        padding: 0 1.3rem;
      }
    }
  }
}
.page-3{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_3.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page3Warp{
    .content{
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      flex-direction: column;
      .title{
        font-size: 1.5rem;
      }
      .list{
          padding: 0 1.3rem;
      }
    }
  }
}
.page-2{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page2Warp{
    .content{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: flex-start;
      padding: 0 1.3rem;
      box-sizing: border-box;
      color: #fff;
      overflow: hidden;
      .info{
        padding: 1.5rem 0 1rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title{
          font-size: 1.5rem;
        }
        .pl{
          margin: auto;
          margin-top: 1rem;
        }
        .desc{
          overflow: hidden;
          flex: 1;
          margin-top: 1.2rem;
          font-size: .9rem;
          line-height: 1.4rem;

          background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 0));
          background-clip: text;
          -webkit-background-clip: text;
          text-fill-color: transparent;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
}

.page-1{
  .page1Warp{
    display: flex;
    .welcomeText{
      position: fixed;
      height: 100%;
      z-index: 11;
      top: 0;
      left: 0;
      width: 100%;
      color: #fff;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      font-size: 2.4rem;
      margin-top: -2rem;
      .welcomeTextWarp{
        display: inline-block;
        margin: auto;
      }
      .ttvItem{
        transition: 1.5s;
        opacity: 0;
        //margin-top: 2rem;
      }
      .ttv1{
        margin-top: .5rem;
      }
    }
    img{
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      object-fit: cover;
    }
    video,.video{
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      object-fit: cover;
    }
  }
}
.mobileWarp{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
.fullpage-container{
  //background: red;
}
</style>
